// eslint-disable-next-line import/named
import { getAPPID } from '../components/common/Helpers';

export const getApiUrls = {
  /* common URLs for prospect & existing customers urls */
  otpOnMail: '/inspicioservice/inspicio/5g/send-otp-email',
  validateOtpMail: '/inspicioservice/inspicio/5g/validate-email-otp',
  fccReviewUrl: '/content/wcms/broadband-facts/consumer.html',
  fccReviewUrlNationRetailer: '/content/wcms/broadband-facts/national.html',
  reDirectToUrl: '/qualificationservice/5g/reDirectTo',
  reDirectUrl: '/qualificationservice/5g/reDirect',
  contactInfourl: '/contactInfo/data',
  basetemplateurl: '/basetemplate/data',
  appointmenturl: '/appointment/data',
  addOnAddressurl: '/addOns/fetchE911Address',
  addOnnpaurl: '/addOns/npanxx',
  addressAutoFillUrl: '/locus-typeahead/address/typeahead-address',
  addressAutoFillUnitUrl: '/locus-typeahead/address/typeahead-loc-unit',
  get5GAppConfigFlag: '/shippinghandlingservice/shipping/get5GAppConfigFlag',
  addressAutoFillSoeUrl: getAPPID() === 'NSE' ? '/shippinghandlingservice/shipping/nse/typeahead' : '/shippinghandlingservice/shipping/typeahead',
  addressAutoFillUnitSoeUrl:
    getAPPID() === 'NSE' ? '/shippinghandlingservice/shipping/nse/5g/unitTypeAhead' : '/shippinghandlingservice/shipping/5g/unitTypeAhead',
  ntasAddressUrl: '/atomapi/v1/addresslookup/addresses/street',
  generateToken: '/inhome/generatetoken',
  getAddonsPromos: '/content/caas/5g-lte-flow.model.json',
  getAddonsPromos_Prod: 'https://www.verizonwireless.com/caas/5g-lte-flow.model.json',
  getConfirmationPromos: '/content/caas/5g-lte-config.model.json',
  getConfirmationPromos_Prod: 'https://www.verizon.com/content/caas/5g-lte-config.model.json',
  LTE_RouterImagesURL:
    'https://mobile.vzw.com/hybridClient/is/image/VerizonWireless/verizon-lte-home-internet-router-mms?req=set,json,UTF-8&callback=s7jsonResponse',
  LTE_D2D_RouterImagesURL:
    'https://ss7.vzw.com/is/image/VerizonWireless/verizon-lte-home-internet-router-mms?req=set,json,UTF-8&callback=s7jsonResponse',
  GEMINI_RouterImagesURL:
    'https://mobile.vzw.com/hybridClient/is/image/VerizonWireless/verizon-5g-home-internet-gateway-white-mms?req=set,json,UTF-8&callback=s7jsonResponse',
  GEMINI_D2D_RouterImagesURL:
    'https://ss7.vzw.com/is/image/VerizonWireless/verizon-5g-home-internet-gateway-white-mms?req=set,json,UTF-8&callback=s7jsonResponse',
  LUNA_RouterImagesURL: '',
  LUNA_D2D_RouterImagesURL: '',
  cartAddOnurl: '/cartservice/cart/add-features',
  orderConfirmationurl: '/orderConfirmation/data',
  parentChildBaseTemplateurl: '/parentChildBaseTemplate/data',
  getSectionsurl: '/getSections',
  getSectionsDataurl: '/getSectionsData',
  reviewOrderurl: '/reviewOrder/data',
  getProductReferenceurl: '/content/vcg/homeservices/productreference.model.json',
  updateNSEContactInfoURL: '/orderprocessservice/checkoutapi/nse/5g/updatePersonalBillingPinInfo',
  getCartDetailsurlForAddon: '/cart/getCartDetailsAddon',
  updateShippingOptionurl: '/shippingOptions/updateData',
  shopNowurl: '/products/shop/5g-home-internet-accessories/',
  crmResumeCart: '/cartservice/cart/nse/5g/crmResumeCart',
  ltePlansurl: '/homePlans/getLTEPlans',
  get5GSelfAppointments: '/appointmentservice/appointment/get5GAppointments',
  getCheckoutDetails: '/orderprocessservice/checkoutapi/get-checkout-details',
  getSMSEnabledDevices: '/fraudservice/OTP/getSMSEnabledDevices',
  sendSMS: '/fraudservice/OTP/generateOTP',
  validateOTP: '/fraudservice/OTP/validateOTP',
  getSddSlotDetails: '/shippinghandlingservice/shipping/checkSDDEligibility',
  zipMarketDetailsUrl: '/shippinghandlingservice/ispu/nse/retrieveZipcodeMktDetails',
  runCreditReviewUrl: '/orderprocessservice/checkoutapi/nse/5g/initiateCreditCheck',
  reSubmitCredit: '/orderprocessservice/checkoutapi/nse/reSubmitCredit',
  generateSecureToken: '/orderprocessservice/nse/cca/generateSecureToken',
  redirect5Ghome: '/5g/home/',
  redirectHome: '/home/internet',
  redirectAddressSearch: '/sales/home/addressSearch.html',
  redirectNextgenCart: '/sales/nextgen/expresscart.html',
  redirectNGDCart: '/nextgendigital/sales/configurator/cart',
  redirectCart: '/sales/home/cart.html',
  redirectAddons: '/sales/home/addons.html',
  redirectSetup: '/sales/home/setup.html',
  redirectShipping: '/sales/home/shipping.html',
  redirectDeviceUpgrade: '/sales/home/DeviceUpgrade.html',
  redirectPayment: '/sales/home/payment.html',
  redirectExpressTOS: '/sales/home/expresstos.html',
  redirectConfirmation: '/sales/home/confirmation.html',
  accFailurl: '/sales/home/expresscart.html?ACCFail=Y',
  broadBandFacts: '/sales/home/broadBandFacts.html',
  collections_INDurl: '/sales/home/expresscart.html?collections_IND=Y',
  cashOnlyUrl: '/sales/home/expresscart.html?cashonly=Y',
  ONFraudOrderUrl: '/sales/home/expresscart.html?fraudorder=Y',
  errorLogUrl: '/peripheralsservice/jsNotifyAsDynamic',
  homePlansTaggingUrl: '/omnidlservice/5g/readDL',
  broadBandUrl: '/support/broadband-services/',
  mfAppBroadBandUrl: 'https://www.verizon.com/support/broadband-services/',
  partnerCheckAvlUrl: '/qualificationservice/nse/fiosCheck5GAvailability',
  inspicioSendLink: '/soe/digital/prospect/inspicioservice/inspicio/5g/sendSMSEmail-inspicio',
  inspicioReceiveUrl: '/inspicioservice/inspicio/receiveMessage',
  smartLeadsHandShakeURL: '/qualificationservice/nse/5g/d2d/invokeSmartLeads',
  saveCartURL: '/cartservice/cart/nse/5g/saveCartWithEmail',
  pinvalidateUrl: '/soe/digital/prospect/qualificationservice/nse/5g/dtdPinValidation',
  confirmSale: '/orderprocessservice/d2d/5g/sendOrderConfirmation',
  getInspicioIdUrl: '/soe/digital/prospect/inspicioservice/inspicio/generateInspicioID',
  inspicioSendMessage: '/inspicioservice/inspicio/sendMessage',
  validateEmailVds: '/fraudservice/validate/nse/5g/emailValidate',
  validatePhone: '/consentservice/consent/nse/getSMSConsent',
  estimatedBillSummary: '/orderprocessservice/nbsapi/nextbillsummary',
  packageSelection: '/browseservice/grid/plans/5g/PackageSelection',
  promoContentMockUrl: '/browseservice/grid/plans/5g/promoContentMockUrl',
  pushMessage: '/qualificationservice/vfw/pushMessage',
  lqInit: '/qualificationservice/vfw/lqInit',
  eupRetriveCart: '/cartservice/cart/5g/swap/retrieve-cart',
  eupOrderSubmit: '/orderprocessservice/orderwriteapi/5g/swap/orderWrite',
  eupValidateOrder: '/cartservice/cart/5g/swap/validateOrder',
  eupValidateCart: '/cartservice/cart/5g/swap/validate-cart',
  eupUpdateCart: '/cartservice/cart/5g/swap/updateCart',
  eupInitiate5GUpgrade: '/qualificationservice/nse/5g/swap/initiate5GUpgrade',
  eupGetAuthToken: '/orderprocessservice/5g/swap/getAuthToken',
  eupCheck5GUpgradeEligibility: '/qualificationservice/5g/swap/check5GUpgradeEligibility',
  eupOrderConfirmation: '/cartservice/cart/5g/swap/order-confirmation',
  getMoveInDetails: '/cartservice/vfw/getMoveinQualificationDetails',
  initMoversService: '/qualificationservice/vfw/initmovers',
  getd2dAuthToken: '/soe/digital/prospect/orderprocessservice/d2d/5g/getd2dAuthToken',
  brtc: '/orderprocessservice/d2d/nse/5g/cancelOrderBRTC',
  cBandPlansDetails: '/content/caas/c-band.model.json',
  planInformationDetails: '/content/support/terms/products/important-plan-information/_jcr_content.raw.json',
  willowFEDURL: '/content/caas/willow-plans/willow-plan-overview.model.json',
  moversPlansDetailsFEDUrl: '/content/caas/willow-plans/willow-plan-overview.model.json',
  moversImportantAccountChangesAEMUrl: '/homeservices/moversImportantAccountChanges.model.json',
  moversPlansDetails: '/content/caas/movers-plans/movers-plan-overview.model.json',
  moversComparePlanDetails: '/plansservice/plans/5g/movers/comparePlan',
  broadBandFactURL: getAPPID() === 'NSE' ? '/plansservice/nse/5g/getFccPlanReference' : '/plansservice/5g/getFccPlanReference',
  fccProspectPlans: '/plansservice/nse/5g/getFccProspectPlans',
  prepaidFccProspectPlans: '/prepayservice/plans/nse/5g/getFccProspectPlans',
  perkModalDetails: '/content/caas/plan/perks.model.json',
  newBrowsingURL: '/plansservice/nse/5g/getPlansSurcharge',
  videoCall: '/mediaservice/getmediastats',
  cbandInitiateRepair: '/qualificationservice/nse/5g/cbd/initiate-repair',
  cbandAuthToken: '/orderprocessservice/nse/5g/cbd/get-auth-token',
  cbandLoad5GOrder: '/orderprocessservice/readorderapi/5g/cbd/load-5g-order',
  cbandCheckEligiblity: '/qualificationservice/5g/cbd/check-eligiblity',
  techvalidateCart: '/cartservice/cart/5g/cbd/validate-cart',
  techRetriveCart: '/cartservice/cart/5g/cbd/retrieve-cart',
  techUpdateCart: '/cartservice/cart/5g/cbd/update-cart',
  techvalidateOrder: '/cartservice/cart/5g/cbd/validate-order',
  techtermsAndConditionsurl: '/orderprocessservice/checkoutapi/5g/cbd/get-terms-conditions',
  techSubmitOrderUrl: '/orderprocessservice/orderwriteapi/5g/cbd/orderWrite',
  techOrderConfirmationUrl: '/cartservice/cart/5g/cbd/order-confirmation',
  techcbdAssignMtn: '/cartservice/cart/5g/cbd/assign-mtn',
  techcbdRetreiveNpanxx: '/assignmtnservice/retreive-npanxx',
  techcbdsignatureCapture: '/activationprovisionservice/5g/cbd/signatureCapture',
  cbandValidatePin: '/qualificationservice/5g/cbd/validate-pin',
  techcbdLoadPlanSize: '/browseservice/grid/browse/loadPlanSize',
  generateInspecioTocken: '/inspicioservice/inspicio/generateInspicioID',
  sendEmailForInspecio: '/inspicioservice/inspicio/5g/sendSMSEmail-inspicio',
  nse5GProcessEidFlow: '/orderprocessservice/checkoutapi/nse/5g/processEidFlow',
  redirectEupDevicePage: '/sales/home/eup/eupdevicesetup.html',
  redirectEupPendingOrderPage: '/sales/home/eup/euppendingorder.html',
  redirectTechLandingPage: '/sales/home/tech/landing.html',
  techCbdSendOtpEmail: '/inspicioservice/inspicio/cbd/send-otp-email',
  techCbdValidateEmailOtp: '/inspicioservice/inspicio/cbd/validate-email-otp',
  techReviewOrderData: '/cartservice/cart/5g/cbd/getReviewOrderData',
  techCbdDeclineTandc: '/orderprocessservice/checkoutapi/5g/cbd/decline-tandc',
  cpcGetMtnAndEmail: '/qualificationservice/5g/tech/getMtnAndEmail',
  cpcGenerateInspicioID: '/inspicioservice/inspicio/generateInspicioID',
  cpcSendSMSEmailInspicio: '/inspicioservice/inspicio/5g/sendSMSEmail-inspicio',
  WHWSendSMSEmailInspicio: '/inspicioservice/inspicio/sendSMSEmail-OM',
  redirectCpclandingPage: '/sales/home/cpc/cpclanding.html',
  redirectwhwTechLanding: '/sales/home/whwTech/whwLanding.html',
  cpcValidatePin: '/qualificationservice/5g/tech/validate-pin',
  cpcGetPlan: '/plansservice/plans/5g/tech/getCpcAvailablePlans',
  getwhwEligibilities: '/accountlandingservice/get-whw-eligibilities',
  cpcVpmAddPlans: '/cartservice/cart/addUpgradeDetails',
  initiateCPCAPI: '/qualificationservice/5g/tech/nse/initiate-cpc',
  nonNSEInitiateCPCAPI: '/qualificationservice/5g/tech/initiate-cpc',
  vpmCPCGetPlan: '/plansservice/nse/plans/5g/tech/getCpcAvailablePlans',
  vpmGetwhwEligibilities: '/accountlandingservice/nse/get-whw-eligibilities',
  vpmAddPlansFeatAcc: '/cartservice/cart/nse/addUpgradeDetails',
  cpcUpdateCart: '/cartservice/cart/5g/tech/cpcUpdateCart',
  cpcSubmitPlan: '/cartservice/cart/5g/tech/cpcSubmit-plan',
  cpcOrderConfirmationUrl: '/cartservice/cart/5g/tech/order-confirmation',
  expressCartUrl: '/sales/home/expresscart.html?expresscart=true&addplan=false',
  sessionLogoff: '/fraudservice/session/logout',
  importantPlanInfo: '/support/important-plan-information/?type=app',
  updateCustomerMoveDates: '/cartservice/cart/5g/movers/updateCustomerMoveDates',
  moversretrieveCart: '/cartservice/cart/5g/movers/retrieve-cart',
  moversUpdateISPUContactInfo: '/shippinghandlingservice/ispu/5g/movers/updateISPUContactInfo',
  moversShippingAddress: '/shippinghandlingservice/shipping/5g/movers/updateShippingAddress',
  moversRetrieveEquipment: '/orderprocessservice/checkoutapi/5g/movers/retrieveEquipmentList',
  moversUpdateShippingOptions: '/shippinghandlingservice/shipping/5g/movers/updateShippingOptions',
  moversProAppointment: '/appointmentservice/appointment/5g/movers/save5GProAppointment',
  moversUpdateCart: '/cartservice/cart/5g/movers/updateCart',
  moversOrderWrite: '/orderprocessservice/orderwriteapi/5g/movers/orderWrite',
  moversUpdateCustomerPlan: '/cartservice/cart/5g/movers/updateCustomerPlan',
  moversValidateCartAndCheckout: '/cartservice/cart/validateCartAndCheckout',
  redirectPayBalance: '/digital/nsa/secure/ui/payment/paybill/',
  redirectPMD: '/digital/nsa/secure/ui/cpc/#/',
  redirectHomePlans: '/sales/home/plans.html',
  streamLineOrder: '/sales/home/streamlineordering.html',
  cpcCheckCbandAvailability: '/qualificationservice/5g/tech/checkCbandAvailability',
  redirectContactInfo: '/sales/home/contactinfo.html',
  redirectShippingInfo: '/sales/home/shipping.html',
  redirectBroadBandFacts: '/sales/home/broadBandFacts.html',
  qualificationCheckAvlUrl: '/browseservice/qualification/createCaseAndGetCustInfo',
  qualificationCheckQueryParamUrl: '/browseservice/qualification/createCaseAndGetCustInfo?tdu=true',
  qualificationCheckAteQueryParamUrl: '/browseservice/qualification/createCaseAndGetCustInfo?tdu=true&ate=true',
  qualificationCheckTrupQueryParamUrl: '/browseservice/qualification/createCaseAndGetCustInfo?tdu=true&e=true',
  checkFWAUpgradeEligibilityUrl: '/browseservice/checkFWAUpgradeEligibility',
  checkFWAUpgradeEligibilityTrupQueryParamUrl: '/browseservice/checkFWAUpgradeEligibility?tdu=true&e=true',
  checkFWAUpgradeEligibilityEQueryParamUrl: '/browseservice/checkFWAUpgradeEligibility?e=true',
  fwaDeviceUpgradeCreateCartUrl: '/cartservice/fwaDeviceUpgradeCreateCart',
  addDevice: '/cartservice/cart/add-device',
  /* similar URLs for prospect & existing customers */
  homePlansurl: getAPPID() === 'NSE' ? '/browseservice/grid/plans/nse/5g/homeInternetDetails' : '/browseservice/grid/plans/5g/homeInternetDetails',
  getCartDetailsurl: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/retrieve-cart' : '/cartservice/cart/5g/retrieve-cart',
  addOnsurl: getAPPID() === 'NSE' ? '/browseservice/grid/nse/5g/getAddOnsDetails' : '/browseservice/grid/5g/getAddOnsDetails',
  paymentInfourl: getAPPID() === 'NSE' ? '/paymentservice/nse/5g/retrievePaymentOptions' : '/paymentservice/5g/retrievePaymentOptions',
  shippingDetailurl:
    getAPPID() === 'NSE' ? '/shippinghandlingservice/shipping/nse/5g/getShippingOptions' : '/shippinghandlingservice/shipping/5g/getShippingOptions',
  termsAndConditionsurl:
    getAPPID() === 'NSE' ? '/orderprocessservice/checkoutapi/nse/5g/getAgreementDetails' : '/orderprocessservice/checkoutapi/5g/getAgreementDetails',
  updateContactInfoURL:
    getAPPID() === 'NSE' ? '/orderprocessservice/checkoutapi/nse/5g/updatePersonalInfo' : '/orderprocessservice/checkoutapi/5g/updatePersonalInfo',
  addSMSConsentURL: '/consentservice/consent/nse/addSMSConsent',
  addAccessories: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/add-accessories' : '/cartservice/cart/5g/add-accessories',
  submitOrder: getAPPID() === 'NSE' ? '/orderprocessservice/orderwriteapi/nse/5g/orderWrite' : '/orderprocessservice/orderwriteapi/5g/orderWrite',
  validateOrder: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/validateOrder' : '/cartservice/cart/5g/validateOrder',
  checkISPUAvailability:
    getAPPID() === 'NSE'
      ? '/shippinghandlingservice/ispu/nse/5g/checkInStoreAvailability'
      : '/shippinghandlingservice/ispu/5g/checkInStoreAvailability',
  updateShippingOptions:
    getAPPID() === 'NSE'
      ? '/shippinghandlingservice/shipping/nse/5g/updateShippingOptions'
      : '/shippinghandlingservice/shipping/5g/updateShippingOptions',
  moversUpdateShipping: '/shippinghandlingservice/shipping/5g/movers/updateShippingOptions',
  updateSelfInstallation:
    getAPPID() === 'NSE'
      ? '/appointmentservice/appointment/nse/5g/save5GSelfAppointment'
      : '/appointmentservice/appointment/5g/save5GSelfAppointment',
  updateProInstallation:
    getAPPID() === 'NSE' ? '/appointmentservice/appointment/nse/5g/save5GProAppointment' : '/appointmentservice/appointment/5g/save5GProAppointment',
  addFeatures: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/add-features' : '/cartservice/cart/5g/add-features',
  updateCartOnAddons: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/updateCart' : '/cartservice/cart/5g/updateCart',
  removeHomePhone: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/remove-lines' : '/cartservice/cart/5g/remove-lines',
  get5GProAppointments:
    getAPPID() === 'NSE' ? '/appointmentservice/appointment/nse/5g/get5GProAppointments' : '/appointmentservice/appointment/5g/get5GProAppointments',
  validateCart: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/validate-cart' : '/cartservice/cart/5g/validate-cart',
  confirmSubmitUrl: getAPPID() === 'NSE' ? '/paymentservice/nse/5g/confirmSubmit' : '/paymentservice/5g/confirmSubmit',
  retreivenpanxx: getAPPID() === 'NSE' ? '/assignmtnservice/nse/retreive-npanxx' : '/assignmtnservice/retreive-npanxx',
  assignNPANXX: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/assign-mtn' : '/cartservice/cart/5g/assign-mtn',
  updateShippingAddress:
    getAPPID() === 'NSE'
      ? '/shippinghandlingservice/shipping/nse/5g/updateShippingAddress'
      : '/shippinghandlingservice/shipping/5g/updateShippingAddress',
  handle3DCardinalResponse: getAPPID() === 'NSE' ? '/paymentservice/nse/5g/handleCardinal3DResponse' : '/paymentservice/5g/handleCardinal3DResponse',
  submitSignature: getAPPID() === 'NSE' ? '/activationprovisionservice/nse/5g/signatureCapture' : '/activationprovisionservice/5g/signatureCapture',
  paypalAuth: getAPPID() === 'NSE' ? '/paymentservice/nse/5g/paypalAuthenticateFromCheckoutNSE' : '/paymentservice/5g/paypalAuthenticateFromCheckout',
  cBandPlans: getAPPID() === 'NSE' ? '/plansservice/plans/nse/5g/getAvailablePlans' : '/plansservice/plans/5g/getAvailablePlans',
  nbxFeedBackApi: getAPPID() === 'NSE' ? '/plansservice/nse/nbxfeedback' : '/plansservice/nbxfeedback',
  subscriptionApi: getAPPID() === 'NSE' ? '/plansservice/nse/getSubscriptions' : '/plansservice/getSubscriptions',
  cBandPlansProgressive: getAPPID() === 'NSE' ? '/plansservice/plans/nse/5g/getfwaplans' : '/plansservice/plans/5g/getfwaplans',
  moversPlans: '/plansservice/plans/5g/movers/getMoversAvailablePlans',
  moversFWAApi: '/plansservice/plans/5g/movers/getAvailablePlans',
  updateCBandPlan: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/add-plan' : '/cartservice/cart/5g/add-plan',
  updateProcessStepAddons: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/updateProcessStep' : '/cartservice/cart/5g/updateProcessStep',
  sessionKeepAlive: getAPPID() === 'NSE' ? '/fraudservice/session/nse/keepalive' : '/fraudservice/session/keepalive',
  isCouponValid: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/validate-apply-coupon' : '/cartservice/cart/5g/validate-apply-coupon',
  accMainEmailVerifyUrl: getAPPID() === 'NSE' ? '/fraudservice/validate/nse/5g/verifyEmail' : '/fraudservice/validate/5g/verifyEmail',
  miniCart: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/getDueMonthlyAndDueToday' : '/cartservice/cart/5g/getDueMonthlyAndDueToday',
  updateISPUContactInfo:
    getAPPID() === 'NSE' ? '/shippinghandlingservice/ispu/5g/nse/updateISPUContactInfo' : '/shippinghandlingservice/ispu/5g/updateISPUContactInfo',
  localOfferBanner: '/plansservice/nse/fetchofferfromnbx',
  validateE911Address:
    getAPPID() === 'NSE' ? '/qualificationservice/vfw/nse/5g/validateE911Address' : '/qualificationservice/vfw/5g/validateE911Address',
  validateEmail: getAPPID() === 'NSE' ? '/fraudservice/validate/nse/emailValidate' : '/fraudservice/validate/5g/emailValidate',
  getCheckoutDetailsurl:
    getAPPID() === 'NSE'
      ? '/orderprocessservice/checkoutapi/nse/v2/5g/get-checkout-details'
      : '/orderprocessservice/checkoutapi/v2/5g/get-checkout-details',
  cradleApi: '/omnidlservice/nse/pegaRequest',
  progressivePlan: '/sales/home/progressiveplan.html',
  addonsnew: '/sales/home/addonsnew.html',
  vfdiscountpage: '/sales/home/vfdiscount.html',
  getAvailableFeatures: '/plansservice/features/getAvailableFeaturesAndSpos',
  vfOrderSubmit: '/orderprocessservice/cpc/submitFeature',
  expressCheckout: '/sales/home/expresscheckout.html',
  visonPendingOrder: '/orderprocessservice/cancelorderapi/whwPendingOrder',
  checkoutCaas: '/homeservices/expresscheckout.model.json',
  privacyPolicyURL: 'https://www.verizon.com/about/privacy/privacy-policy-summary',
  accountRolesURL: 'https://secure.verizon.com/account/roleInfo/start',
  accountOwnerEmailURL: '/cartservice/cart/5g/save-cart',
  deleteCartURL: getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/deleteCart' : '/cartservice/cart/5g/deleteCart',
  getFeatureFlags: '/qualificationservice/lq/fwaDigitalFeatureFlag',
  smartAIAssistant: getAPPID() === 'NSE' ? '/personalizationrecommendationsservice/nse/5g/getFwaVzAIAsstData' : '/personalizationrecommendationsservice/5g/getFwaVzAIAsstData',
  vpmUpgradeRedirectUrl: '/sales/home/plansandFeature/selection.html',
  getCheckout : getAPPID() === 'NSE' ? "/paymentservice/braintree/nse/getCheckout" : "/paymentservice/braintree/getCheckout",
  getClientToken : getAPPID() === 'NSE' ? "/paymentservice/braintree/nse/getClientToken" : "/paymentservice/braintree/getClientToken",
};

/* Prospect only URLs */
export const prospectUrls = {
  addressAutoFillUrl: '/locus-typeahead/address/typeahead-address',
  addressAutoFillUnitUrl: 'locus-typeahead/address/typeahead-loc-unit',
  swithToFRPUrl: '/orderprocessservice/checkoutapi/nse/switchToFRP',
  abandonCart: '/personalizationrecommendationsservice/pdm/nse',
  ntasAddressUrl: '/atomapi/v1/addresslookup/addresses/street',
  generateToken: '/inhome/generatetoken',
  cradleApi: '/omnidlservice/nse/pegaRequest',
  addressAutoFillSoeUrl: getAPPID() === 'NSE' ? '/shippinghandlingservice/shipping/nse/typeahead' : '/shippinghandlingservice/shipping/typeahead',
  addressAutoFillUnitSoeUrl:
    getAPPID() === 'NSE' ? '/shippinghandlingservice/shipping/nse/5g/unitTypeAhead' : '/shippinghandlingservice/shipping/5g/unitTypeAhead',
  hardToGuessPwdValidationUrl: '/orderprocessservice/checkoutapi/nse/hardtoguess-pwd-validation',
};

/* Existing only URLs */
const existingUrls = {};

const nseUrls = { ...prospectUrls, ...getApiUrls };
const authUrls = { ...existingUrls, ...getApiUrls };

export const apiUrls = () => {
  if (getAPPID() === 'NSE') {
    return nseUrls;
  }
  return authUrls;
};
